import axios from "axios";
import { useContext } from "react";
import { useRef } from "react";
import Swal from "sweetalert2";
import TasksContext from "../context/tasks-content";
import Tsaks from "../Models/Tsaks";
//(S)OLID =>Single Responsiblity
class NewTaskController{
    nameRef = useRef();
    categoryRef =useRef();
    detailesRef =useRef();
    starDatetRef =useRef();
    endDateRef =useRef();
    tasksContext =useContext(TasksContext);

     onFormSubimitHandler =(event) =>{
        event.preventDefault();
        this.addNewTask();
      }
    addNewTask =()=>{
        if(this.checkForm()){
            const newTaskObject = this.newTasks
            // console.log(`newTasks: ${this.newTasks}`);
            const token = localStorage.getItem("token");
            axios
            .post(`https://vp-react-tasks-642b9-default-rtdb.firebaseio.com/tasks.json?auth=${token}`,
            newTaskObject
           )
            .then((response)=>{
                this.tasksContext.addNewTask(newTaskObject);
                this.clear();
                this.showAlert("success","Task add successfuly","success")
            })
            .catch((error)=>{
                console.log(error);
            });
             
           
        }
    };
    clear(){
        this.nameRef.current.value ="" ;
        this.categoryRef.current.value ="" ;
        this.detailesRef.current.value ="";
        this.starDatetRef.current.value ="" ;
        this.endDateRef.current.value ="" ;

    }

    checkForm = () => { 
        if(
            this.nameRef.current.value !="" &&
            this.categoryRef.current.value !="" &&
            this.detailesRef.current.value !="" &&
            this.starDatetRef.current.value !="" &&
            this.endDateRef.current.value !="" 
            ){
                return true ;
            }
            this.showAlert("Error data" ,"Enter Task Info" , "error")
            return false;
    };
     showAlert =(title , text , icon)=>{
        Swal.fire({
            title: title,
            text: text,
            icon : icon,
            showCancelButton :false,
            showConfirmButton :false,
            timer :1500,
        })
    };

    get newTasks(){
        return new Tsaks(
            Math.random(),
            this.nameRef.current.value ,
            this.categoryRef.current.value ,
            this.detailesRef.current.value ,
            this.starDatetRef.current.value ,
            this.endDateRef.current.value ,
            "Waiting"
        )
    }

    }
export default NewTaskController;